export enum InvoiceTypeEnum {
	'newBusiness' = 'New Business',
	'endorsement' = 'Endorsement',
	'renewal' = 'Renewal',
	'cancellation' = 'Cancellation',
	'reinstatement' = 'Reinstatement',
	'installment' = 'Installment',
	'premiumReporting' = 'Premium Reporting',
	'other' = 'Other',
}
